import { spacing } from "@layout";
import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  container: {
    alignItems: "center",
    userSelect: "none",
  },
  checkbox: {
    marginRight: spacing.xxs,
    transform: "scale(0.65)",
    transformOrigin: "center",
  },
};
